var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-layout',[_c('v-text-field',{staticClass:"mb-3",attrs:{"value":_vm.value,"disabled":_vm.disabled,"rules":[
        _vm.$store.state.validationRules.required,
        _vm.$store.state.validationRules.trackingNo,
        _vm.trackingNoRule
      ],"label":"運單號碼","autofocus":""},on:{"input":function($event){_vm.$emit('input', $event.trim())}}}),(_vm.showConfirmButton)?_c('v-btn',{staticClass:"info",on:{"click":_vm.handleConfirm}},[_vm._v(" 確認 ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }